<template>
  <div class="payment-success-container py-5 mt-5 mb-5">
    <div class="container text-center">
      <div class="card p-5 shadow-sm">
        <i class="fa fa-check-circle text-success fa-5x"></i>
        <h2 class="text-success mt-3">{{ $t("payment.successTitle") }}</h2>
        <p class="mt-2">{{ $t("payment.successMessage") }}</p>

        <div class="alert alert-info mt-3">
          <i class="fa fa-info-circle"></i> {{ $t("payment.ticketInfo") }}
        </div>

        <div class="d-flex justify-content-center gap-3 mt-4">
          <router-link to="/dashboard" class="btn btn-outline-primary">
            <i class="fa fa-user"></i> {{ $t("payment.goToDashboard") }}
          </router-link>

          <router-link to="/" class="btn btn-primary">
            <i class="fa fa-home"></i> {{ $t("payment.returnHome") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.payment-success-container {
  max-width: 600px;
  margin: auto;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.card {
  border-radius: 10px;
  background: white;
}
.alert-info {
  font-size: 1rem;
}
</style>
